import SimpleBar from "simplebar-react";
import { useInterview } from "../../contexts/interview.context";


const reportData = [
    {
      improvementArea: "Develop an understanding of data-driven decision-making concepts.",
      question: "Can you describe your experience with data-driven decision-making? How have you leveraged data to shape product strategies in your previous roles?",
      score: "10%",
      strength: "Willingness to acknowledge lack of experience.",
      userAnswer: "i haven't any expreiance yet",
    },
    {
      improvementArea: "Detail specific methods for gathering customer feedback.",
      question: "Given that you may not have direct experience, how would you approach understanding customer needs and incorporating feedback into a product strategy?",
      score: "20%",
      strength: "Focus on customer satisfaction.",
      userAnswer: "i will satisy the curommers by giving service with quality product.",
    },
    {
      improvementArea: "Expand on communication strategies and collaborative techniques.",
      question: "Can you discuss how you would facilitate cross-functional collaboration among different teams (such as engineering, marketing, and sales) to ensure successful product delivery?",
      score: "15%",
      strength: "Recognition of coordination as a key aspect.",
      userAnswer: "i will cordinate them",
    },
    {
      improvementArea: "Consider brainstorming innovative ideas for user experience.",
      question: "Can you describe any innovations or unique ideas you have that could enhance user experience in a product? How would you go about implementing them?",
      score: "5%",
      strength: "Honesty about experience.",
      userAnswer: "i haven;t any yet",
    },
    {
      improvementArea: "Study essential elements of product strategy and their priorities.",
      question: "In your opinion, what are the key components of a successful product strategy? How would you prioritize these components?",
      score: "0%",
      strength: "Openness to acknowledge gaps in knowledge.",
      userAnswer: "i don't know sir",
    },
  ];
  

const Progress: React.FC<{ value: number }> = ({ value }) => {
  return (
    <div className="w-full bg-gray-200 rounded-full h-4 overflow-hidden">
      <div
        className="bg-accent-500 h-full text-xs text-white text-center flex items-center justify-center"
        style={{ width: `${value}%` }}
      >
        {value}%
      </div>
    </div>
  );
};

const ScoreReport = () => {
    const { interview } = useInterview();
    const scoreReports = interview.interviewData?.scoreReport;
  return (
    <SimpleBar  className={`flex-1  overflow-y-auto overflow-x-hidden md:max-h-[80vh] max-h-[95vh] h-[75vh]  rounded-lg p-3 space-y-2    dark:border-gray-700 dark:bg-[#1d1d1d] border-gray-300 bg-gray-100/50 `}>
      <h1 className="text-2xl font-bold text-center">Interview Score Report</h1>
      {scoreReports?.map((item, index) => (
        <div key={index} className="bg-white dark:bg-slate-900 shadow-md border border-gray-200 rounded-xl p-4">
          <h2 className="text-lg font-semibold dark:text-slate-200 text-gray-800">{item.improvementArea}</h2>
          <p className="text-gray-600 dark:text-slate-100 mt-2"><span className="font-medium">Question:</span> {item.question}</p>
          <p className="text-gray-600 dark:text-slate-100 mt-2"><span className="font-medium">Your Answer:</span> {item.userAnswer}</p>
          <p className="text-gray-600 dark:text-slate-100 mt-2"><span className="font-medium">Strength:</span> {item.strength}</p>
          <div className="mt-4">
            <p className="font-medium text-gray-700 dark:text-slate-100">Score: {item.score}</p>
            <Progress value={parseInt(item.score)} />
          </div>
        </div>
      ))}
                <div className="mt-4">
            <p className="font-medium text-gray-700">Score: {interview.interviewData?.overallScore}</p>
            <Progress value={interview.interviewData?.overallScore || 0} />
          </div>
    </SimpleBar>
  );
};

export default ScoreReport;
